module.exports = __webpack_public_path__ + "img/admin-bonos.3e198191.svg";